import { h, Component } from 'preact'

import { getChannelClient } from 'src/utils/messages/singleton'

import API from '../API'
import ImpactContent from './ImpactContent'

/** @jsx h */

// Height sync now flows through resizeIframe.js (loaded by the impact
// widget's layout) — ResizeObserver on documentElement covers what the
// hand-rolled handleResize + setTimeout retries used to do.
// impactDemoLoaded is still emitted from here since it's a separate
// lifecycle signal, not a resize event.
export default class ImpactState extends Component {
  constructor (props) {
    super(props)

    this.fetchWidget  = this.fetchWidget.bind(this)
    this.openInfo     = this.openInfo.bind(this)
    this.closeInfo    = this.closeInfo.bind(this)

    this.api = API(this)

    this.state = {
      pollInterval: props.pollInterval,
      ...props.widget
    }
  }

  setPollInterval () {
    this.pollInterval = setInterval(this.fetchWidget, this.state.pollInterval)
  }

  fetchWidget () {
    if (this.state.pollInterval)
      fetch(location.pathname + '.json')
      .then(response => {
        if (response.ok)
          response.json().then(json => this.setState(json))
      })
  }

  componentDidMount () {
    this.api.init()
    this.setPollInterval()
    if (self != parent) getChannelClient().send('impactDemoLoaded')
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.pollInterval != prevState.pollInterval) {
      clearInterval(this.pollInterval)
      this.setPollInterval()
    }
  }

  componentWillUnmount () {
    this.api.terminate()
    clearInterval(this.pollInterval)
  }

  openInfo (e) {
    e.preventDefault()
    this.setState({ showInfo: true, flipping: true }, () =>
      setTimeout(() => this.setState({ halfway: true }, () =>
        setTimeout(() => this.setState({ flipping: false }), 620)), 150))
  }

  closeInfo (e) {
    e.preventDefault()
    this.setState({ showInfo: false, flipping: true }, () =>
      setTimeout(() => this.setState({ halfway: false }, () =>
        setTimeout(() => this.setState({ flipping: false }), 620)), 150))
  }

  render () {
    return (
      <ImpactContent
        openInfo={this.openInfo}
        closeInfo={this.closeInfo}
        {...this.props}
        {...this.state}
      />
    )
  }
}
